// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"4486e187","990":"f5102668"}[chunkId] + ".chunk.js";
};